/* tslint:disable */
/* eslint-disable */
/**
 * notifications
 * notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { NotificationPreferenceDeliveryScopeType } from './NotificationPreferenceDeliveryScopeType';
import {
    NotificationPreferenceDeliveryScopeTypeFromJSON,
    NotificationPreferenceDeliveryScopeTypeFromJSONTyped,
    NotificationPreferenceDeliveryScopeTypeToJSON,
} from './NotificationPreferenceDeliveryScopeType';

/**
 * 
 * @export
 * @interface NotificationPreferenceDeliveryScope
 */
export interface NotificationPreferenceDeliveryScope {
    /**
     * 
     * @type {string}
     * @memberof NotificationPreferenceDeliveryScope
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationPreferenceDeliveryScope
     */
    user_id?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationPreferenceDeliveryScope
     */
    preference_id?: string;
    /**
     * 
     * @type {NotificationPreferenceDeliveryScopeType}
     * @memberof NotificationPreferenceDeliveryScope
     */
    relation_type?: NotificationPreferenceDeliveryScopeType;
    /**
     * 
     * @type {string}
     * @memberof NotificationPreferenceDeliveryScope
     */
    relation_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationPreferenceDeliveryScope
     */
    enabled?: boolean;
}

/**
 * Check if a given object implements the NotificationPreferenceDeliveryScope interface.
 */
export function instanceOfNotificationPreferenceDeliveryScope(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function NotificationPreferenceDeliveryScopeFromJSON(json: any): NotificationPreferenceDeliveryScope {
    return NotificationPreferenceDeliveryScopeFromJSONTyped(json, false);
}

export function NotificationPreferenceDeliveryScopeFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationPreferenceDeliveryScope {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'user_id': !exists(json, 'user_id') ? undefined : json['user_id'],
        'preference_id': !exists(json, 'preference_id') ? undefined : json['preference_id'],
        'relation_type': !exists(json, 'relation_type') ? undefined : NotificationPreferenceDeliveryScopeTypeFromJSON(json['relation_type']),
        'relation_id': !exists(json, 'relation_id') ? undefined : json['relation_id'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
    };
}

export function NotificationPreferenceDeliveryScopeToJSON(value?: NotificationPreferenceDeliveryScope | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'user_id': value.user_id,
        'preference_id': value.preference_id,
        'relation_type': NotificationPreferenceDeliveryScopeTypeToJSON(value.relation_type),
        'relation_id': value.relation_id,
        'enabled': value.enabled,
    };
}

